import { lazy } from 'react';

const UserFeedbacks = lazy(() =>
  import('./feedback/page.js').then((module) => ({ default: module.UserFeedbacks })),
);

const Transactions = lazy(() =>
  import('./transactions/page.js').then((module) => ({ default: module.Transactions })),
);

export { Transactions, UserFeedbacks };
